import service from "@/libs/service";
import Vue from "vue";

export const namespaced = true;
const OFFER_EXPIRATION_TIME = parseInt(process.env.VUE_APP_OFFER_EXPIRATION_TIME);

export const state = {
    close: [],
    deleted: [],
    detail: {},
    disable: [],
    filtered: {},
    lastOfferRead: 0,
    list: [],
    new: {
        step: 1,
    },
    open: [],
    postulates: [],
    crud: []
};

export const mutations = {
    SET_OFFERS(state, offers) {
        state.list = offers;
    },
    SET_OFFERS_POSTULATES(state, offers) {
        state.filter = offers;
    },
    SET_OPEN_OFFERS(state, offers) {
        state.open = offers;
    },
    SET_REVIEW_OFFERS(state, offers) {
        state.review = offers;
    },
    SET_FAILED_OFFERS(state, offers) {
        state.failed = offers;
    },
    SET_CLOSED_OFFERS(state, offers) {
        state.close = offers;
    },
    SET_DISABLED_OFFERS(state, offers) {
        state.disable = offers;
    },
    SET_FILTERED_OFFERS(state, offers, nameFilter) {
        state.filtered = {
            ...filtered,
            [nameFilter]: offers,
        };
    },
    SET_LAST_OFFER_READ(state, timestamp) {
        state.lastOfferRead = timestamp;
    },
    SET_DELETED_OFFER(state, offerId) {
        Vue.set(state, "deleted", [...state.deleted, offerId]);
    },
    SET_CRUD_OFFERS(state, offers) {
        state.crud = offers;
    }
};

export const actions = {
    async deleteOffer({ commit }, offer) {
        try {
            const servicePath = "/offers/remove";
            await service.request(servicePath, { offerId: offer.id });
            commit("SET_DELETED_OFFER", offer.id);  
            
            return {
                status: "ok",
            };
        } catch (error) {
            console.error(error);
            return {
                status: "error",
                message: "Hubo un error al eliminar la oferta."
            };
        }
    },
    sheet({ commit }, params) {
        return new Promise((resolve, reject) => {
            if (!params || params === "") {
                reject("Debe venir el ID de la oferta");
            }
            service.request("/assets/sheet", params).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    async getOffers({ commit, getters }, tags) {
        let path = tags ? `/offers?tags=${tags}` : "/offers";

        try {
            if (tags || getters.haveOffersExpired) {
                let { offers } = await service.request(path);
                commit("SET_OFFERS", offers);
            }
            return;
        } catch (error) {
            console.error(error);
            return error;
        }
    },
    list({ commit, getters }, tags) {
        return new Promise((resolve, reject) => {
            let now = new Date().getTime();
            let lastOfferRead = parseInt(localStorage.getItem("lastOfferRead"));
            let path = tags ? `/offers?tags=${tags}` : "/offers";

            // Si hay timestamp de última lectura, setear actual. Sino setear uno nuevo
            /*if (lastOfferRead) {
                commit("SET_LAST_OFFER_READ", lastOfferRead);
            }
            else {
                localStorage.setItem("lastOfferRead", now);
                commit("SET_LAST_OFFER_READ", now);
            }*/

            // Si hay tags o si las ofertas expiraron, llamar servicio
            if (tags || getters.haveOffersExpired) {
                service.request(path).then(content => {
                    commit("SET_OFFERS", content.offers);
                    // Si expiraron las ofertas, actualizar timestamp última lectura
                    if (getters.haveOffersExpired) {
                        commit("SET_LAST_OFFER_READ", now);
                    }
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            } else {
                resolve();
            }

        });
    },
    offers({ commit }, params) {
        return new Promise((resolve, reject) => {
            let content = {
                matchs: {
                    status: ["open", "disable"]
                },
                order: ["updatedAt", "DESC"],
                limit: params && params.limit ? params.limit : parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                offset: params && params.limit ? (params.page - 1) * params.limit : (params.page - 1) * parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE)
            };
            if (params.tags) {
                content.tags = params.tags;
            }
            if (params.role === "sysadmin" && params.status) {
                content.matchs.status = [];
                params.status.forEach(s => {
                    content.matchs.status.push(s);
                });
            }
            if (params.role === "sysadmin" && params.offset) {
                content.offset = params.offset;
            }
            if (params.role === "admin") {
                content.matchs.status.push("review");
                content.matchs.status.push("failed");
            }

            service.request("/offers/match", content).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    open({ commit }, params) {
        return new Promise((resolve, reject) => {
            let content = {
                matchs: {
                    status: ["open", "disable"]
                },
                limit: parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                offset: (params.page - 1) * parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                order: ["updatedAt", "DESC"]
            };

            if (params.tags) {
                content.tags = params.tags;
            }
            if (params.role == "admin") {
                content.matchs.status.push("review");
                content.matchs.status.push("failed");
            }

            service.request("/offers/match", content).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    review({ commit }, params) {
        return new Promise((resolve, reject) => {
            let content = {
                matchs: {
                    status: ["review"]
                },
                limit: parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                offset: (params.page - 1) * parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                order: ["createdAt", "DESC"]
            };

            if (params.tags) {
                content.tags = params.tags;
            }
            service.request("/offers/match", content).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    failed({ commit }, params) {
        return new Promise((resolve, reject) => {
            let content = {
                matchs: {
                    status: ["failed"]
                },
                limit: parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                offset: (params.page - 1) * parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                order: ["createdAt", "DESC"]
            };

            if (params.tags) {
                content.tags = params.tags;
            }
            service.request("/offers/match", content).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    close({ commit }, params) {
        return new Promise((resolve, reject) => {
            let content = {
                matchs: {
                    status: ["close"]
                },
                limit: parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                offset: (params.page - 1) * parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE),
                order: ["moderatedAt", "DESC"]
            };

            if (params.tags) {
                content.tags = params.tags;
            }
            service.request("/offers/match", content).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    disable({ commit }) {
        return new Promise((resolve, reject) => {
            service.request("/offers/match/status/disable").then(content => {
                commit("SET_DISABLED_OFFERS", content.offers);
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    filter({ commit }, filter) {
        return new Promise((resolve, reject) => {
            service.request(`/offers/match/${filter.key}/${filter.value}`).then(content => {
                commit("SET_FILTERED_OFFERS", content.filtered, filter.key);
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    get({ commit }, slug) {
        return new Promise((resolve, reject) => {
            service.request("/offers/slug/" + slug).then(content => {
                resolve(content.offer);
            }).catch(err => {
                reject(err);
            });
        });
    },
    update({ commit }, params) {
        return new Promise((resolve, reject) => {
            service.request("/offers/update", params).then(() => {
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    postulates({ commit }, id) {
        return new Promise((resolve, reject) => {
            service.request(`/organization/${id}/offers`).then(content => {
                commit("SET_OFFERS_POSTULATES", content);
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    recordClose({ commit }, body) {
        return new Promise((resolve, reject) => {
            service.request("/offers/close", body).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    recordNps({ commit }, body) {
        return new Promise((resolve, reject) => {
            service.request("/offers/nps", body).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    updateNotified({ commit }, body) {
        return new Promise((resolve, reject) => {
            service.request("/offers/postulations/update/notified", body).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    expiredToClose() {
        return new Promise((resolve, reject) => {
            service.request("/offers/expired").then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    }
};

export const getters = {
    haveOffersExpired(state) {
        let { lastOfferRead } = state;
        let now = new Date().getTime();
        // Retorna boolean según diferencia entre ahora y última lectura ofertas.
        // Si no hay última lectura ofertas, retorna null
        return now - lastOfferRead > OFFER_EXPIRATION_TIME;
    },
    getCrudOffers(state) {
        return state.crud;
    },
    getList(state) {
        return state.list;
    },
    getOffersByOrg(state) {
        return state.postulates;
    },
    getOpen(state) {
        return state.open;
    },
    getFailed(state) {
        return state.failed;
    },
    getDisable(state) {
        return state.disable;
    },
    getReview(state) {
        return state.review;
    },
    getClose(state) {
        return state.close;
    },
    getFiltered(state) {
        return state.filtered;
    },
    sortedOffers(state) {
        return state.list.sort(function(a, b) {
            return (b.weight - a.weight) || (new Date(b.moderatedAt) - new Date(a.moderatedAt));
        });
    },
    featuredOffers(state, getters) {
        let featuredOffers = getters.sortedOffers.filter(offer => offer.weight >= 100);
        let pinnedOffers = JSON.parse(localStorage.getItem("offerSave"));

        // Agregar ofertas guardadas al principio
        if (pinnedOffers && pinnedOffers.length > 0) {
            pinnedOffers.forEach(element => {
                let index = featuredOffers.findIndex(item => item.id === element);
                if (index !== -1) {
                    let itemSave = featuredOffers[index];
                    featuredOffers.splice(index, 1);
                    featuredOffers.unshift(itemSave);
                }
            });
        }
        return featuredOffers;
    },
    normalOffers(state, getters) {
        let normalOffers = getters.sortedOffers.filter(offer => offer.weight < 100);
        let pinnedOffers = JSON.parse(localStorage.getItem("offerSave"));
        
        // Agregar ofertas guardadas al principio
        if (pinnedOffers && pinnedOffers.length > 0) {
            pinnedOffers.forEach(element => {
                let index = normalOffers.findIndex(item => item.id === element);
                if (index !== -1) {
                    let itemSave = normalOffers[index];
                    normalOffers.splice(index, 1);
                    normalOffers.unshift(itemSave);
                }
            });
        }
        return normalOffers;
    },
};

export default {
    // state,
    // mutations,
    // getters,
    actions
};
